/**
 * Checkbox states as values
 */
export const CheckboxState = {
    UNSELECTED: 'UNSELECTED',
    SELECTED: 'SELECTED',
    DISABLED_UNSELECTED: 'DISABLED_UNSELECTED',
    DISABLED_SELECTED: 'DISABLED_SELECTED',
    ERROR_UNSELECTED: 'ERROR_UNSELECTED',
    ERROR_SELECTED: 'ERROR_SELECTED',
};
//# sourceMappingURL=state.js.map